import { Injectable } from '@angular/core';
import { Institution } from '../model/institution';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { Subject } from 'rxjs';
import { User, IFavorite } from '../model/user';
import { Config } from '../model/config';
import { ConfigService } from '../services/config.service';

@Injectable()
export class SaveService {

  institution: Institution;
  title: string = "";
  user: User;
  config: Config;

  titleChange: Subject<string> = new Subject<string>();
  userChange: Subject<User> = new Subject<User>();

  constructor(private configService: ConfigService) {
    this.titleChange
      .subscribe((value) => { this.title = value });
    this.userChange
      .subscribe((value) => { this.user = value });
  }

  clearAll() {
    this.institution = null;
    this.config = null;
    this.title = null;
    this.user = null;
  }

  setInstitution(institution: Institution) {
    this.institution = institution;
  }

  getInstitution() {
    return this.institution;
  }

  setConfig(config: Config) {
    this.config = config;
  }

  getConfig() {
    return this.config;
  }

  getConfigInstitutionID() {
    return this.config.institutionId;
  }

  getNextConfigInstitutionID() {
    let num = parseInt(this.config.institutionId.slice(1, 6)) + 1;
    this.config.institutionId = ("U" + this.pad(num, 5));
    this.configService.saveConfig(this.config);
    return this.config.institutionId;
  }

  pad(num, size) {
    var s = "000000000" + num;
    return s.substr(s.length - size);
  }

  setConfigInstitutionID(institutionId) {
    this.config.institutionId = institutionId;
  }

  setTitle(title: string) {
    this.title = title;
    this.titleChange.next(this.title);
  }

  setUser(user: User) {
    this.user = user;
    this.userChange.next(this.user);
  }

  getUser(): User {
    return this.user
  }

  getUserId(): string {
    return this.user.$key
  }

  getUserType(): string {
    if (this.user) {
      return this.user.userType
    } else {
      return null
    }

  }

  addUserFavorite(userId: string) {
    const favorite: IFavorite = { institution: userId, type: "FAVORITE" };
    this.user.favoriteInstitution.push(favorite);
    this.userChange.next(this.user);
  }

  removeUserFavorite(userId: string) {
    const index = this.user.favoriteInstitution.findIndex(uid => {
      return (uid.institution === userId) ? true : false
    }
    );
    if (index > -1) {
      this.user.favoriteInstitution.splice(index, 1);
    }
    this.userChange.next(this.user);
  }

  getUserFavorite(): string[] {
    let favorite: string[] = [];
    this.user.favoriteInstitution.map(fav => {
      if (fav.type === "ADMIN" || fav.type === "FAVORITE") {
        favorite.push(fav.institution);
      }
    })
    return favorite
  }

  isUserFavorite(userId: string): boolean {
    console.log("isUserFavorite = userId = ", userId)
    const index = this.user.favoriteInstitution.findIndex(uid => {
      console.log("this.user.favoriteInstitution = ", this.user.favoriteInstitution)
      console.log("uid = ", uid)
      return (uid.institution === userId) ? true : false
    }
    );
    console.log("index = ", index)
    return (index !== -1);
  }

}



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/shared/services/save.service.ts